var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 81,
    viewBox: "0 0 80 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8475_1548)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.3335 16.9261C13.3335 16.0421 13.6847 15.1942 14.3098 14.5691C14.9349 13.944 15.7828 13.5928 16.6668 13.5928H63.3335C64.2176 13.5928 65.0654 13.944 65.6905 14.5691C66.3156 15.1942 66.6668 16.0421 66.6668 16.9261V63.5928C66.6668 64.4768 66.3156 65.3247 65.6905 65.9498C65.0654 66.5749 64.2176 66.9261 63.3335 66.9261H16.6668C15.7828 66.9261 14.9349 66.5749 14.3098 65.9498C13.6847 65.3247 13.3335 64.4768 13.3335 63.5928V16.9261Z",
    stroke: "#BF4036",
    strokeWidth: 5.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3335 26.9268H66.6668",
    stroke: "#BF4036",
    strokeWidth: 5.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.6665 13.5928V26.9261",
    stroke: "#BF4036",
    strokeWidth: 5.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.6665 48.5928L36.6665 53.5928L46.6665 43.5928",
    stroke: "#BF4036",
    strokeWidth: 5.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8475_1548"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    fill: "white",
    transform: "translate(0 0.259766)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUi);
export default __webpack_public_path__ + "static/media/ui.cef5af2e7e4020b07305b4ff81c18b50.svg";
export { ForwardRef as ReactComponent };